import { clearPrintCart } from './print-cart-storage';
import { clearPrintCheckoutAttempt } from './print-checkout-attempt';

export const AUTH_STORAGE_KEYS = ['token', 'refresh', 'tokenExpirationTime', 'messages'];

export const clearAuthStorage = (storage = window.localStorage) => {
  try {
    AUTH_STORAGE_KEYS.forEach((key) => storage.removeItem(key));
    return { ok: true };
  } catch (error) {
    return { ok: false, reason: 'storage-error' };
  }
};

export const clearLogoutStorage = (storage = window.localStorage) => {
  const authResult = clearAuthStorage(storage);
  if (!authResult.ok) return authResult;
  const cartResult = clearPrintCart(storage);
  if (!cartResult.ok) return cartResult;
  return clearPrintCheckoutAttempt(storage);
};
